import axios from 'axios';

// Dynamically determine API URL based on current host
const getApiBaseUrl = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const port = window.location.port;

  // Development: localhost with separate ports (frontend:3000, backend:5000)
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    if (port === '3000' || port === '') {
      return `${protocol}//${hostname}:5000/api`;
    }
  }

  // Production: Traefik routes /api to backend on same host
  return `${protocol}//${hostname}/api`;
};

const api = axios.create({
  baseURL: getApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
